import posts from '../content/blogs.generated.json';
export interface BlogPost {
  slug: string;
  title: string;
  description: string;
  image: string;
  date: string;
  updated?: string;
  author: string;
  content: string;
}
// One build-time content source: articles are present in the first HTML response.
export const blogs: BlogPost[] = posts;
export const getAllBlogs = async (): Promise<BlogPost[]> => blogs;
export const getBlogBySlug = async (slug: string): Promise<BlogPost | null> => blogs.find(post => post.slug === slug) || null;
export const formatBlogDate = (date: string, long = false) => new Date(date).toLocaleDateString('en-GB', {day: 'numeric', month: long ? 'long' : 'short', year: 'numeric', timeZone: 'UTC'});
